import { PlainDateSwitcher, PlainDateSwitcherProps } from './plain-date-switcher'
import { PlainDateSwitcherDouble, PlainDateSwitcherDoubleProps } from './plain-date-switcher-double'


export default PlainDateSwitcher
export { PlainDateSwitcher, PlainDateSwitcherDouble }
export type { PlainDateSwitcherProps, PlainDateSwitcherDoubleProps }
